module.exports = __webpack_public_path__ + "img/badge-8k.26f4fdb4.svg";